import React, { useContext, useState, useEffect } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Sternchen from './Bilder/Sternchen klein.png';
import Menu from './Menu';
import Infobar from './Infobar';

import ValueContext from './Context';
import './Übersicht.css';

export default function Uebersicht() {
  const { locale, getText, version } = useContext(ValueContext);
  const [img, setimg] = useState();
  const [text, settext] = useState(getText());
  const [menuActive, setmenuActive] = useState(false);

  function loadImage() {
    let swVersion = version;
    if (version === '4.1') {
      swVersion = '4.0';
    }
    setimg('/mc/images/'.concat('Navigationsstruktur', swVersion, locale, '.png'));
  }

  useEffect(() => {
    settext(getText());
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, version]);

  return (
    <>
      <div className='Infobar'>
        <Infobar onclick={() => setmenuActive(!menuActive)} />
      </div>
      {menuActive ? (
        <Menu onclick={() => setmenuActive(!menuActive)} />
      ) : (
        <div className='ImageWrapper'>
          <SimpleBar
            style={{ maxHeight: 380, minHeight: 380 }}
            scrollbarMinSize='30'
            autoHide={false}
            forceVisible={'y'}>
            <img className='Übersicht' src={img} alt='Übersicht' />
          </SimpleBar>
          <div className='ÜbersichtLegende'>
            <img className='ÜbersichtPremiumStars' src={Sternchen} alt='Sterne' /> ={' '}
            {text.Übersicht.Premium} <br />
            <span className='ÜbersichtNumberFormat'>1</span>= {text.Übersicht.First} <br />
            <span className='ÜbersichtNumberFormat'>2</span>= {text.Übersicht.Second} <br />
            <span className='ÜbersichtNumberFormat'>3</span>= {text.Übersicht.Third} <br />
            <span className='ÜbersichtNumberFormat'>4</span>= {text.Übersicht.Fourth}
          </div>
        </div>
      )}
    </>
  );
}
